import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { QRListingQuery, Root } from './types'

export const fetchQRListing = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: QRListingQuery }) => {
  return wretchClient
    .url('/admin/1.0/sites/doors/qr')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<Root>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const generateQR = async (params: { abortCtrl?: AbortController, siteId: string, numberOfQR: number }) => {
  return wretchClient
    .url(`/admin/1.0/sites/${params.siteId}/doors/qr`)
    .signal(params?.abortCtrl)
    .query({ range: params.numberOfQR })
    .post()
    .json()
}

export const fetchQRImages = async (params: { abortCtrl?: AbortController, siteIds: string | string[] }) => {
  const siteIds = Array.isArray(params.siteIds) ? params.siteIds.join(',') : params.siteIds

  const data = await wretchClient
    .url(`/admin/1.0/sites/doors/qr/${siteIds}/images`)
    .signal(params?.abortCtrl)
    .get()
    .res()

  const blob = new Blob([await data.blob()], { type: 'application/pdf' })
  const timestamp = new Date().toISOString().replace(/[:.]/g, '-')
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `Door_QR_${timestamp}.pdf`
  link.click()
  window.URL.revokeObjectURL(link.href)
}
